var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1194.455,
    height: 1023.695,
    viewBox: "0 0 1194.455 1023.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbd79d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_29",
    x: 562.4,
    y: 8.029,
    width: 632.055,
    height: 714.582,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4",
    x: 0,
    y: 0,
    width: 655.414,
    height: 730.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4-2",
    x: 347.711,
    y: 94.696,
    width: 508,
    height: 641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 577.5,
    cy: 437,
    rx: 577.5,
    ry: 437,
    transform: "translate(-0.289 143.696)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(706.888 8.029) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -698.02, 159.58)",
    filter: "url(#Path_29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M35.366,0h413.21a35.366,35.366,0,0,1,35.366,35.366V561.88a35.366,35.366,0,0,1-35.366,35.366H35.366A35.366,35.366,0,0,1,0,561.88V35.366A35.366,35.366,0,0,1,35.366,0Z",
    transform: "translate(715.89 14.03) rotate(14)",
    fill: "#dadada"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M13.685-24.745A12.111,12.111,0,0,0,1.225-12.25,12.091,12.091,0,0,0,13.72.21,11.939,11.939,0,0,0,25.655-9.31v-4.27H12.425v3.745h8.4A6.633,6.633,0,0,1,13.9-4.2c-4.55,0-7.63-3.08-7.63-8.05,0-4.865,3.045-7.98,7.42-7.98a6.143,6.143,0,0,1,5.74,3.15H25.06C23.485-21.98,19.145-24.745,13.685-24.745ZM34.195-9.66c0-3.745,1.75-4.865,4.655-4.865h1.295V-19.67a6.725,6.725,0,0,0-5.95,3.29v-3.01H29.3V0h4.9ZM62.16-9.7A9.582,9.582,0,0,0,52.185-19.7,9.582,9.582,0,0,0,42.21-9.7c0,6.09,4.235,10.01,9.835,10.01C57.68.315,62.16-3.605,62.16-9.7Zm-14.98,0c0-3.885,2.345-5.74,4.935-5.74S57.12-13.58,57.12-9.7c0,3.85-2.485,5.74-5.075,5.74C49.42-3.955,47.18-5.845,47.18-9.7ZM64.5-9.7c0,6.09,3.99,10.01,9.59,10.01,4.83,0,8.085-2.73,9.135-6.86H77.945a3.7,3.7,0,0,1-3.885,2.66c-2.73,0-4.55-2.03-4.55-5.81s1.82-5.845,4.55-5.845a3.809,3.809,0,0,1,3.885,2.7H83.23c-1.05-4.34-4.3-6.86-9.135-6.86C68.495-19.7,64.5-15.785,64.5-9.7Zm30.66-5.985a4.308,4.308,0,0,1,4.62,4.165h-9.2A4.5,4.5,0,0,1,95.165-15.68Zm9.205,9.59H99.085A4,4,0,0,1,95.2-3.745a4.537,4.537,0,0,1-4.655-4.48H104.72a11.453,11.453,0,0,0,.14-1.89c0-5.775-3.955-9.59-9.555-9.59-5.74,0-9.73,3.885-9.73,10.01,0,6.09,4.1,10.01,9.73,10.01A9.012,9.012,0,0,0,104.37-6.09Zm8.96-3.57c0-3.745,1.75-4.865,4.655-4.865h1.295V-19.67a6.725,6.725,0,0,0-5.95,3.29v-3.01h-4.9V0h4.9Zm17.5,3.815L125.825-19.39H120.33L128.1-.49l-4.2,9.66h5.215l12-28.56H135.9ZM152.075-24.43V0h12.95V-3.885h-8.05V-24.43ZM168.14,0h4.9V-19.39h-4.9Zm2.485-21.7a2.894,2.894,0,0,0,3.01-2.87,2.894,2.894,0,0,0-3.01-2.87,2.873,2.873,0,0,0-3.01,2.87A2.873,2.873,0,0,0,170.625-21.7ZM192.92-5.53c-.14-7.105-10.885-4.9-10.885-8.435,0-1.12.945-1.855,2.765-1.855,1.925,0,3.115,1.015,3.255,2.52h4.69c-.28-3.85-3.115-6.4-7.8-6.4-4.795,0-7.665,2.59-7.665,5.81,0,7.105,10.955,4.9,10.955,8.365,0,1.12-1.05,2-2.975,2-1.96,0-3.325-1.12-3.5-2.59H176.82c.21,3.605,3.6,6.44,8.47,6.44C190.015.315,192.92-2.2,192.92-5.53Zm4.795-.49c0,4.445,2.485,6.02,6.2,6.02h3.08V-4.13h-2.275c-1.54,0-2.065-.56-2.065-1.855v-9.38h4.34V-19.39h-4.34v-4.8h-4.935v4.8H195.4v4.025h2.31Z",
    transform: "translate(136.641 81.592)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(85.913 174.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1.161-9.423a9.232,9.232,0,0,0,9.4,9.585c4.077,0,7.317-2.025,8.721-5.643H16.335a5.939,5.939,0,0,1-5.778,3.51c-3.942,0-6.885-2.862-6.885-7.452,0-4.617,2.943-7.479,6.885-7.479a5.921,5.921,0,0,1,5.778,3.537h2.943a8.858,8.858,0,0,0-8.721-5.7A9.278,9.278,0,0,0,1.161-9.423ZM22.923,0H25.38V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563V0h2.43V-8.721c0-4.239-2.619-6.345-5.913-6.345a5.567,5.567,0,0,0-4.887,2.4V-19.98H22.923ZM46.494-12.96a4.342,4.342,0,0,1,4.671,4.482H41.823A4.582,4.582,0,0,1,46.494-12.96Zm6.912,8.4H50.76A4.066,4.066,0,0,1,46.6-1.836,4.651,4.651,0,0,1,41.8-6.48H53.622A13.319,13.319,0,0,0,53.7-7.965a6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,53.406-4.563Zm9.828-8.4A4.342,4.342,0,0,1,67.9-8.478H58.563A4.582,4.582,0,0,1,63.234-12.96Zm6.912,8.4H67.5a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,58.536-6.48H70.362a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,70.146-4.563Zm14.175.54c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H72.873c.162,2.7,2.592,4.59,6.048,4.59C82.188.243,84.321-1.593,84.321-4.023Zm9.747-8.937a4.342,4.342,0,0,1,4.671,4.482H89.4A4.582,4.582,0,0,1,94.068-12.96Zm6.912,8.4H98.334a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,89.37-6.48H101.2a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,100.98-4.563Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(85.913 355.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M4.536-9.882v-6.912H8.154c2.808,0,4,1.3,4,3.483,0,2.106-1.188,3.429-4,3.429Zm10.125-3.429c0-3.078-2.079-5.508-6.507-5.508H2.079V0H4.536V-7.857H8.154C12.825-7.857,14.661-10.449,14.661-13.311ZM31.752-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,31.752-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,5,1.755,5,5.481,0,3.753-2.511,5.508-5.076,5.508S19.305-3.672,19.305-7.425ZM35.532-4.05c0,2.97,1.485,4.05,4.1,4.05H41.85V-2.079H40.041c-1.512,0-2.052-.513-2.052-1.971v-8.721H41.85V-14.8H37.989v-3.726H35.532V-14.8H33.615v2.025h1.917Zm8.37-3.4c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H56.43v2.7a6.14,6.14,0,0,0-5.508-2.943C46.953-15.039,43.9-12.069,43.9-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.295-5.454,4.995-5.454S56.43-10.854,56.43-7.425ZM63.612-4.05c0,2.97,1.485,4.05,4.1,4.05H69.93V-2.079H68.121c-1.512,0-2.052-.513-2.052-1.971v-8.721H69.93V-14.8H66.069v-3.726H63.612V-14.8H61.7v2.025h1.917ZM86.94-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,86.94-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,5,1.755,5,5.481,0,3.753-2.511,5.508-5.076,5.508S74.493-3.672,74.493-7.425Zm26.325,3.4c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H89.37c.162,2.7,2.592,4.59,6.048,4.59C98.685.243,100.818-1.593,100.818-4.023Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(85.952 235.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M20.061-9.423a9.267,9.267,0,0,0-9.45-9.612,9.283,9.283,0,0,0-9.45,9.612A9.283,9.283,0,0,0,10.611.189,9.267,9.267,0,0,0,20.061-9.423Zm-16.389,0c0-4.617,2.97-7.479,6.939-7.479S17.55-14.04,17.55-9.423c0,4.59-2.97,7.479-6.939,7.479S3.672-4.833,3.672-9.423ZM34.128,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345a5.466,5.466,0,0,0-4.752,2.376V-14.8H23.3V0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563Zm6.453,0h2.457V-14.8H40.581ZM41.85-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674,1.648,1.648,0,0,0-1.674,1.674A1.648,1.648,0,0,0,41.85-17.2ZM61.263-7.425a7.222,7.222,0,0,0-7.479-7.614A7.237,7.237,0,0,0,46.3-7.425c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,61.263-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,5,1.755,5,5.481,0,3.753-2.511,5.508-5.076,5.508S48.816-3.672,48.816-7.425ZM75.33,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345A5.466,5.466,0,0,0,66.96-12.69V-14.8H64.5V0H66.96V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563ZM92.421-4.023c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H80.973c.162,2.7,2.592,4.59,6.048,4.59C90.288.243,92.421-1.593,92.421-4.023Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(86.154 416.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "salt",
    transform: "translate(53.818 28)",
    fontSize: 27,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "salt"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(85.819 295.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M.918-16.821H6.075V0H8.532V-16.821h5.13v-2H.918Zm29.808,9.4a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,30.726-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S18.279-3.672,18.279-7.425ZM55.323,0h2.43V-8.721c0-4.239-2.619-6.345-5.994-6.345a5.477,5.477,0,0,0-5.238,3.294,5.567,5.567,0,0,0-5.427-3.294,5.349,5.349,0,0,0-4.671,2.4V-14.8H33.966V0h2.457V-8.154c0-3.186,1.7-4.779,4.185-4.779,2.43,0,4.05,1.539,4.05,4.563V0h2.43V-8.154c0-3.186,1.7-4.779,4.185-4.779,2.43,0,4.05,1.539,4.05,4.563Zm5.535-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0H75.87V-14.8H73.386v2.7a6.14,6.14,0,0,0-5.508-2.943C63.909-15.039,60.858-12.069,60.858-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.295-5.454,4.995-5.454S73.386-10.854,73.386-7.425ZM80.568-4.05c0,2.97,1.485,4.05,4.1,4.05h2.214V-2.079H85.077c-1.512,0-2.052-.513-2.052-1.971v-8.721h3.861V-14.8H83.025v-3.726H80.568V-14.8H78.651v2.025h1.917ZM103.9-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,103.9-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,5,1.755,5,5.481,0,3.753-2.511,5.508-5.076,5.508S91.449-3.672,91.449-7.425Zm26.325,3.4c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511h-2.538c.162,2.7,2.592,4.59,6.048,4.59C115.641.243,117.774-1.593,117.774-4.023Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(84.809 472.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12-2",
    "data-name": "Rectangle 12",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M2.079,0H4.536V-13.959L10.773,0H12.5l6.21-13.932V0h2.457V-18.684H18.549L11.637-3.24,4.725-18.684H2.079ZM24.408-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0H39.42V-14.8H36.936v2.7a6.14,6.14,0,0,0-5.508-2.943C27.459-15.039,24.408-12.069,24.408-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.3-5.454,4.995-5.454S36.936-10.854,36.936-7.425Zm5.724,0c0,4.7,3,7.668,7.209,7.668,3.672,0,6.075-2.052,6.831-5H54.054a3.969,3.969,0,0,1-4.185,2.916c-2.7,0-4.7-1.917-4.7-5.589,0-3.618,2-5.535,4.7-5.535a4.031,4.031,0,0,1,4.185,2.916H56.7c-.756-3.1-3.159-5-6.831-5C45.657-15.039,42.66-12.069,42.66-7.425Zm23.6-.027c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0H81.27V-14.8H78.786v2.7a6.14,6.14,0,0,0-5.508-2.943C69.309-15.039,66.258-12.069,66.258-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S78.786-10.854,78.786-7.425ZM96.255,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345a5.466,5.466,0,0,0-4.752,2.376V-14.8H85.428V0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563Zm5.535-7.452c0,4.59,3.051,7.7,7.02,7.7a6.077,6.077,0,0,0,5.508-3.024V0H116.8V-19.98h-2.484v7.83a6.453,6.453,0,0,0-5.481-2.889C104.841-15.039,101.79-12.069,101.79-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S114.318-10.854,114.318-7.425Zm12.933-2a9.232,9.232,0,0,0,9.4,9.585c4.077,0,7.317-2.025,8.721-5.643h-2.943a5.939,5.939,0,0,1-5.778,3.51c-3.942,0-6.885-2.862-6.885-7.452,0-4.617,2.943-7.479,6.885-7.479a5.921,5.921,0,0,1,5.778,3.537h2.943a8.858,8.858,0,0,0-8.721-5.7A9.278,9.278,0,0,0,127.251-9.423ZM149.013,0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563V0h2.43V-8.721c0-4.239-2.619-6.345-5.913-6.345a5.567,5.567,0,0,0-4.887,2.4V-19.98h-2.457Zm23.571-12.96a4.342,4.342,0,0,1,4.671,4.482h-9.342A4.582,4.582,0,0,1,172.584-12.96Zm6.912,8.4H176.85a4.066,4.066,0,0,1-4.158,2.727,4.651,4.651,0,0,1-4.806-4.644h11.826a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.105,7.668,7.317,7.668A6.653,6.653,0,0,0,179.5-4.563Zm9.828-8.4a4.342,4.342,0,0,1,4.671,4.482h-9.342A4.582,4.582,0,0,1,189.324-12.96Zm6.912,8.4H193.59a4.066,4.066,0,0,1-4.158,2.727,4.651,4.651,0,0,1-4.806-4.644h11.826a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.105,7.668,7.317,7.668A6.653,6.653,0,0,0,196.236-4.563Zm14.175.54c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511h-2.538c.162,2.7,2.592,4.59,6.048,4.59C208.278.243,210.411-1.593,210.411-4.023Zm9.747-8.937a4.342,4.342,0,0,1,4.671,4.482h-9.342A4.582,4.582,0,0,1,220.158-12.96Zm6.912,8.4h-2.646a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,215.46-6.48h11.826a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.105,7.668,7.317,7.668A6.653,6.653,0,0,0,227.07-4.563Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(224.277 107.362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 18.452,
    cy: 18.452,
    rx: 18.452,
    ry: 18.452,
    fill: "#75a483"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(9.871 10.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0V17.163",
    transform: "translate(8.581 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M0,0V17.163",
    transform: "translate(17.163 8.581) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "matrix(0.956, -0.292, 0.292, 0.956, 0, 141.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14-2",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 34.52, -143.68)",
    filter: "url(#Rectangle_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4-3",
    "data-name": "Rectangle 4",
    width: 483.943,
    height: 597.246,
    rx: 23,
    transform: "matrix(0.96, -0.29, 0.29, 0.96, 9, 147.49)",
    fill: "#dadada"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M13.685-24.745A12.111,12.111,0,0,0,1.225-12.25,12.091,12.091,0,0,0,13.72.21,11.939,11.939,0,0,0,25.655-9.31v-4.27H12.425v3.745h8.4A6.633,6.633,0,0,1,13.9-4.2c-4.55,0-7.63-3.08-7.63-8.05,0-4.865,3.045-7.98,7.42-7.98a6.143,6.143,0,0,1,5.74,3.15H25.06C23.485-21.98,19.145-24.745,13.685-24.745ZM29.3,0h4.9V-19.39H29.3ZM31.78-21.7a2.894,2.894,0,0,0,3.01-2.87,2.894,2.894,0,0,0-3.01-2.87,2.873,2.873,0,0,0-3.01,2.87A2.873,2.873,0,0,0,31.78-21.7ZM39.55,0h4.97V-15.365h3.4V-19.39h-3.4V-20.2c0-2.17.805-2.94,3.185-2.87v-4.13c-5.46-.14-8.155,2.065-8.155,6.825v.98h-2.2v4.025h2.2ZM51.87-6.02C51.87-1.575,54.355,0,58.065,0h3.08V-4.13H58.87c-1.54,0-2.065-.56-2.065-1.855v-9.38h4.34V-19.39h-4.34v-4.8H51.87v4.8H49.56v4.025h2.31ZM73.01,0h4.9V-24.43h-4.9Zm8.47-9.765C81.48-3.71,85.4.315,90.335.315a7.328,7.328,0,0,0,6.37-3.185V0h4.97V-25.9h-4.97v9.2A7.956,7.956,0,0,0,90.37-19.7C85.4-19.7,81.48-15.82,81.48-9.765Zm15.26.07c0,3.675-2.45,5.705-5.145,5.705-2.625,0-5.11-2.1-5.11-5.775S88.97-15.4,91.6-15.4C94.29-15.4,96.74-13.37,96.74-9.7ZM114.8-15.68a4.308,4.308,0,0,1,4.62,4.165h-9.2A4.5,4.5,0,0,1,114.8-15.68Zm9.205,9.59H118.72a4,4,0,0,1-3.885,2.345,4.537,4.537,0,0,1-4.655-4.48h14.175a11.453,11.453,0,0,0,.14-1.89c0-5.775-3.955-9.59-9.555-9.59-5.74,0-9.73,3.885-9.73,10.01,0,6.09,4.1,10.01,9.73,10.01A9.012,9.012,0,0,0,124.005-6.09Zm2.8-3.675c0,6.055,3.92,10.08,8.82,10.08a7.647,7.647,0,0,0,6.44-3.15V0H147V-19.39h-4.935v2.765a7.668,7.668,0,0,0-6.4-3.08C130.725-19.7,126.805-15.82,126.805-9.765Zm15.26.07c0,3.675-2.45,5.705-5.145,5.705-2.625,0-5.11-2.1-5.11-5.775S134.3-15.4,136.92-15.4C139.615-15.4,142.065-13.37,142.065-9.7Zm24.78,4.165c-.14-7.105-10.885-4.9-10.885-8.435,0-1.12.945-1.855,2.765-1.855,1.925,0,3.115,1.015,3.255,2.52h4.69c-.28-3.85-3.115-6.4-7.805-6.4-4.795,0-7.665,2.59-7.665,5.81,0,7.105,10.955,4.9,10.955,8.365,0,1.12-1.05,2-2.975,2-1.96,0-3.325-1.12-3.5-2.59h-4.935c.21,3.605,3.6,6.44,8.47,6.44C163.94.315,166.845-2.2,166.845-5.53Z",
    transform: "translate(155.514 77.715)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23-2",
    "data-name": "Group 23",
    transform: "translate(85.912 174.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-3",
    "data-name": "Rectangle 10",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M.918-16.821H6.075V0H8.532V-16.821h5.13v-2H.918Zm29.808,9.4a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,30.726-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S18.279-3.672,18.279-7.425Zm21.3,4.617L34.938-14.8H32.211L38.178-.162,35.262,6.966H37.8L46.71-14.8H44.172ZM55.458-7.425c0,4.7,3,7.668,7.209,7.668,3.672,0,6.075-2.052,6.831-5H66.852a3.969,3.969,0,0,1-4.185,2.916c-2.7,0-4.7-1.917-4.7-5.589,0-3.618,2-5.535,4.7-5.535a4.031,4.031,0,0,1,4.185,2.916H69.5c-.756-3.1-3.159-5-6.831-5C58.455-15.039,55.458-12.069,55.458-7.425Zm16.389-.027c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H84.375v2.7a6.14,6.14,0,0,0-5.508-2.943C74.9-15.039,71.847-12.069,71.847-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S84.375-10.854,84.375-7.425Zm9.1-.621c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4H91.017V0h2.457Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-2",
    "data-name": "Group 26",
    transform: "translate(85.912 355.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-4",
    "data-name": "Rectangle 10",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1.161-9.423a9.232,9.232,0,0,0,9.4,9.585c4.077,0,7.317-2.025,8.721-5.643H16.335a5.939,5.939,0,0,1-5.778,3.51c-3.942,0-6.885-2.862-6.885-7.452,0-4.617,2.943-7.479,6.885-7.479a5.921,5.921,0,0,1,5.778,3.537h2.943a8.858,8.858,0,0,0-8.721-5.7A9.278,9.278,0,0,0,1.161-9.423ZM22-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H34.533v2.7a6.14,6.14,0,0,0-5.508-2.943C25.056-15.039,22-12.069,22-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.3-5.454,4.995-5.454S34.533-10.854,34.533-7.425ZM52,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345a5.466,5.466,0,0,0-4.752,2.376V-14.8H41.175V0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752C50.355-12.933,52-11.394,52-8.37Zm5.535-7.452c0,4.59,3.051,7.7,7.02,7.7a6.077,6.077,0,0,0,5.508-3.024V0h2.484V-19.98H70.065v7.83a6.453,6.453,0,0,0-5.481-2.889C60.588-15.039,57.537-12.069,57.537-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.295-5.454,4.995-5.454S70.065-10.854,70.065-7.425ZM76.707,0h2.457V-14.8H76.707Zm1.269-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674A1.648,1.648,0,0,0,76.3-18.873,1.648,1.648,0,0,0,77.976-17.2ZM89.64-12.96a4.342,4.342,0,0,1,4.671,4.482H84.969A4.582,4.582,0,0,1,89.64-12.96Zm6.912,8.4H93.906a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,84.942-6.48H96.768a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,96.552-4.563Zm14.175.54c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H99.279c.162,2.7,2.592,4.59,6.048,4.59C108.594.243,110.727-1.593,110.727-4.023Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-2",
    "data-name": "Group 24",
    transform: "translate(85.952 235.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-3",
    "data-name": "Rectangle 11",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M4.536-9.882v-6.912H8.154c2.808,0,4,1.3,4,3.483,0,2.106-1.188,3.429-4,3.429Zm10.125-3.429c0-3.078-2.079-5.508-6.507-5.508H2.079V0H4.536V-7.857H8.154C12.825-7.857,14.661-10.449,14.661-13.311Zm5.508,5.265c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4H17.712V0h2.457ZM27.783,0H30.24V-14.8H27.783Zm1.269-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674,1.648,1.648,0,0,0-1.674,1.674A1.648,1.648,0,0,0,29.052-17.2ZM45.252,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345a5.466,5.466,0,0,0-4.752,2.376V-14.8H34.425V0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563Zm5.535-7.425c0,4.7,3,7.668,7.209,7.668,3.672,0,6.075-2.052,6.831-5H62.181A3.969,3.969,0,0,1,58-1.836c-2.7,0-4.7-1.917-4.7-5.589,0-3.618,2-5.535,4.7-5.535a4.031,4.031,0,0,1,4.185,2.916h2.646c-.756-3.1-3.159-5-6.831-5C53.784-15.039,50.787-12.069,50.787-7.425Zm23.6-5.535a4.342,4.342,0,0,1,4.671,4.482H69.714A4.582,4.582,0,0,1,74.385-12.96Zm6.912,8.4H78.651a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,69.687-6.48H81.513a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,81.3-4.563Zm14.175.54c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H84.024c.162,2.7,2.592,4.59,6.048,4.59C93.339.243,95.472-1.593,95.472-4.023Zm14.094,0c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.1,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511H98.118c.162,2.7,2.592,4.59,6.048,4.59C107.433.243,109.566-1.593,109.566-4.023Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25-2",
    "data-name": "Group 25",
    transform: "translate(85.819 295.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12-3",
    "data-name": "Rectangle 12",
    transform: "translate(0 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.14,
    height: 26.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25.14,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M2.079-18.819V0h9.045V-2H4.536V-18.819ZM12.825-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H25.353v2.7a6.14,6.14,0,0,0-5.508-2.943C15.876-15.039,12.825-12.069,12.825-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S25.353-10.854,25.353-7.425Zm9.1-4.644V-14.8H32V7.02h2.457V-2.727A6.4,6.4,0,0,0,39.987.243c3.969,0,7.02-3.105,7.02-7.7,0-4.617-3.051-7.587-7.02-7.587A6.25,6.25,0,0,0,34.452-12.069ZM44.5-7.452c0,3.483-2.3,5.535-5.022,5.535-2.673,0-5.022-2.025-5.022-5.508,0-3.429,2.349-5.481,5.022-5.481C42.2-12.906,44.5-10.935,44.5-7.452Zm6.291,3.4c0,2.97,1.485,4.05,4.1,4.05H57.1V-2.079H55.3c-1.512,0-2.052-.513-2.052-1.971v-8.721H57.1V-14.8H53.244v-3.726H50.787V-14.8H48.87v2.025h1.917ZM74.115-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,74.115-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S61.668-3.672,61.668-7.425Zm18.144-4.644V-14.8H77.355V7.02h2.457V-2.727A6.4,6.4,0,0,0,85.347.243c3.969,0,7.02-3.105,7.02-7.7,0-4.617-3.051-7.587-7.02-7.587A6.25,6.25,0,0,0,79.812-12.069ZM89.856-7.452c0,3.483-2.295,5.535-5.022,5.535-2.673,0-5.022-2.025-5.022-5.508,0-3.429,2.349-5.481,5.022-5.481C87.561-12.906,89.856-10.935,89.856-7.452Z",
    transform: "translate(53.818 28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21-2",
    "data-name": "Group 21",
    transform: "translate(224.277 107.362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3",
    cx: 18.452,
    cy: 18.452,
    rx: 18.452,
    ry: 18.452,
    fill: "#75a483"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20-2",
    "data-name": "Group 20",
    transform: "translate(9.871 10.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M0,0V17.163",
    transform: "translate(8.581 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M0,0V17.163",
    transform: "translate(17.163 8.581) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(347.514 94.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14-3",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -356.51, -100.87)",
    filter: "url(#Rectangle_4-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4-4",
    "data-name": "Rectangle 4",
    width: 490,
    height: 623,
    rx: 23,
    transform: "translate(356.71 100.7)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M8.68-8.505V0h4.9V-8.505L21.84-24.43H16.38L11.165-13.265,5.915-24.43H.385ZM43.4-9.7A9.582,9.582,0,0,0,33.425-19.7,9.582,9.582,0,0,0,23.45-9.7c0,6.09,4.235,10.01,9.835,10.01C38.92.315,43.4-3.605,43.4-9.7Zm-14.98,0c0-3.885,2.345-5.74,4.935-5.74S38.36-13.58,38.36-9.7c0,3.85-2.485,5.74-5.075,5.74C30.66-3.955,28.42-5.845,28.42-9.7Zm36.89-9.7H60.375V-8.715c0,3.115-1.68,4.8-4.34,4.8-2.59,0-4.305-1.68-4.305-4.8V-19.39h-4.9V-8.015c0,5.32,3.255,8.26,7.77,8.26a7.151,7.151,0,0,0,5.775-2.7V0H65.31Zm9.73,9.73c0-3.745,1.75-4.865,4.655-4.865H80.99V-19.67a6.725,6.725,0,0,0-5.95,3.29v-3.01h-4.9V0h4.9ZM91.315-20.475h6.51V0h4.9V-20.475h6.51V-24.43H91.315Zm20.23,10.71c0,6.055,3.92,10.08,8.82,10.08a7.647,7.647,0,0,0,6.44-3.15V0h4.935V-19.39h-4.935v2.765a7.668,7.668,0,0,0-6.4-3.08C115.465-19.7,111.545-15.82,111.545-9.765Zm15.26.07c0,3.675-2.45,5.705-5.145,5.705-2.625,0-5.11-2.1-5.11-5.775s2.485-5.635,5.11-5.635C124.355-15.4,126.805-13.37,126.805-9.7Zm24.78,4.165c-.14-7.105-10.885-4.9-10.885-8.435,0-1.12.945-1.855,2.765-1.855,1.925,0,3.115,1.015,3.255,2.52h4.69c-.28-3.85-3.115-6.4-7.805-6.4-4.795,0-7.665,2.59-7.665,5.81,0,7.105,10.955,4.9,10.955,8.365,0,1.12-1.05,2-2.975,2-1.96,0-3.325-1.12-3.5-2.59h-4.935c.21,3.605,3.6,6.44,8.47,6.44C148.68.315,151.585-2.2,151.585-5.53ZM155.61,0h4.9V-8.26L167.09,0h6.37l-8.61-9.66,8.54-9.73h-6.37l-6.51,8.225V-25.9h-4.9ZM191.1-5.53c-.14-7.105-10.885-4.9-10.885-8.435,0-1.12.945-1.855,2.765-1.855,1.925,0,3.115,1.015,3.255,2.52h4.69c-.28-3.85-3.115-6.4-7.8-6.4-4.795,0-7.665,2.59-7.665,5.81,0,7.105,10.955,4.9,10.955,8.365,0,1.12-1.05,2-2.975,2-1.96,0-3.325-1.12-3.5-2.59H175c.21,3.605,3.6,6.44,8.47,6.44C188.195.315,191.1-2.2,191.1-5.53Z",
    transform: "translate(147.197 81.828)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-5",
    "data-name": "Rectangle 10",
    transform: "translate(87.197 188.828)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-4",
    "data-name": "Rectangle 11",
    transform: "translate(87.197 251.828)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12-4",
    "data-name": "Rectangle 12",
    transform: "translate(87.197 314.828)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Laundry",
    transform: "translate(141.197 210.828)",
    fontSize: 27,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Laundry")), /*#__PURE__*/React.createElement("text", {
    id: "Clean_room",
    "data-name": "Clean room",
    transform: "translate(141.197 273.828)",
    fontSize: 27,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Clean room")), /*#__PURE__*/React.createElement("text", {
    id: "Shopping",
    transform: "translate(141.197 336.828)",
    fontSize: 27,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Shopping")), /*#__PURE__*/React.createElement("text", {
    id: "list",
    transform: "translate(369.197 335.828)",
    fill: "#004cff",
    fontSize: 23,
    fontFamily: "Poppins-Regular, Poppins",
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "list")), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 392.106,
    transform: "translate(51.512 403.638)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(49.205 442.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M10.962,5.022V4.779A20.929,20.929,0,0,1,5.292-9.882a20.653,20.653,0,0,1,6.075-15.093v-.243H8.8C4.968-21.681,2.916-15.984,2.916-9.882c0,6.075,2.052,11.529,5.481,14.9ZM14.337,0h2.457V-13.959L23.031,0h1.728l6.21-13.932V0h2.457V-18.684H30.807L23.9-3.24,16.983-18.684H14.337ZM36.666-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H49.194v2.7a6.14,6.14,0,0,0-5.508-2.943C39.717-15.039,36.666-12.069,36.666-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.295-5.454,4.995-5.454S49.194-10.854,49.194-7.425Zm9.1-.621c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4H55.836V0h2.457Zm6.7.594c0,4.59,3.051,7.7,7.02,7.7a6.183,6.183,0,0,0,5.508-3.024V.324c0,3.159-1.971,4.833-4.59,4.833-2.43,0-4.185-1.215-4.725-3h-2.43c.486,3.159,3.267,5.13,7.155,5.13C77.274,7.29,80,4.4,80,.324V-14.8H77.517v2.7a6.1,6.1,0,0,0-5.508-2.943C68.04-15.039,64.989-12.069,64.989-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S77.517-10.854,77.517-7.425ZM90.45-12.96a4.342,4.342,0,0,1,4.671,4.482H85.779A4.582,4.582,0,0,1,90.45-12.96Zm6.912,8.4H94.716a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,85.752-6.48H97.578a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,97.362-4.563Zm2.754,9.585V4.779a20.929,20.929,0,0,0,5.67-14.661,20.653,20.653,0,0,0-6.075-15.093v-.243h2.565c3.834,3.537,5.886,9.234,5.886,15.336,0,6.075-2.052,11.529-5.481,14.9ZM119.853-8.856h10.773v-2.079H119.853ZM154.494,0h2.457V-18.819h-2.457v8.262h-9.585v-8.262h-2.457V0h2.457V-8.532h9.585Zm20.655-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,175.149-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S162.7-3.672,162.7-7.425ZM199.746,0h2.43V-8.721c0-4.239-2.619-6.345-5.994-6.345a5.477,5.477,0,0,0-5.238,3.294,5.567,5.567,0,0,0-5.427-3.294,5.349,5.349,0,0,0-4.671,2.4V-14.8h-2.457V0h2.457V-8.154c0-3.186,1.7-4.779,4.185-4.779,2.43,0,4.05,1.539,4.05,4.563V0h2.43V-8.154c0-3.186,1.7-4.779,4.185-4.779,2.43,0,4.05,1.539,4.05,4.563ZM212.49-12.96a4.342,4.342,0,0,1,4.671,4.482h-9.342A4.582,4.582,0,0,1,212.49-12.96Zm6.912,8.4h-2.646A4.066,4.066,0,0,1,212.6-1.836a4.651,4.651,0,0,1-4.806-4.644h11.826a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.105,7.668,7.317,7.668A6.653,6.653,0,0,0,219.4-4.563ZM225.828,0h2.538l3.564-11.745L235.494,0h2.538l4.617-14.8h-2.43L236.871-2.349,233.28-14.8h-2.511L227.1-2.376,223.7-14.8h-2.511Zm33.291-7.425a7.222,7.222,0,0,0-7.479-7.614,7.237,7.237,0,0,0-7.479,7.614c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,259.119-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S246.672-3.672,246.672-7.425Zm18.144-.621c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4h-2.457V0h2.457ZM272.43,0h2.457V-6.534L280.692,0h3.348l-6.993-7.425,6.966-7.371h-3.429l-5.7,6.561V-19.98H272.43Z",
    transform: "translate(-0.008 27.979)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(386.724 16.146)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 12.301,
    x2: 12.301,
    fill: "none",
    stroke: "#d91b0e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 12.301,
    y2: 12.301,
    fill: "none",
    stroke: "#d91b0e",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,4.119l6.5,6.5L17.109,0",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 350.065, 19.116)",
    fill: "none",
    stroke: "#429e55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M10.962,5.022V4.779A20.929,20.929,0,0,1,5.292-9.882a20.653,20.653,0,0,1,6.075-15.093v-.243H8.8C4.968-21.681,2.916-15.984,2.916-9.882c0,6.075,2.052,11.529,5.481,14.9ZM14.337,0h2.457V-13.959L23.031,0h1.728l6.21-13.932V0h2.457V-18.684H30.807L23.9-3.24,16.983-18.684H14.337ZM36.666-7.452c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H49.194v2.7a6.14,6.14,0,0,0-5.508-2.943C39.717-15.039,36.666-12.069,36.666-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-4.995-2.052-4.995-5.535,2.295-5.454,4.995-5.454S49.194-10.854,49.194-7.425Zm9.1-.621c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4H55.836V0h2.457Zm6.7.594c0,4.59,3.051,7.7,7.02,7.7a6.183,6.183,0,0,0,5.508-3.024V.324c0,3.159-1.971,4.833-4.59,4.833-2.43,0-4.185-1.215-4.725-3h-2.43c.486,3.159,3.267,5.13,7.155,5.13C77.274,7.29,80,4.4,80,.324V-14.8H77.517v2.7a6.1,6.1,0,0,0-5.508-2.943C68.04-15.039,64.989-12.069,64.989-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.3-5.454,5-5.454S77.517-10.854,77.517-7.425ZM90.45-12.96a4.342,4.342,0,0,1,4.671,4.482H85.779A4.582,4.582,0,0,1,90.45-12.96Zm6.912,8.4H94.716a4.066,4.066,0,0,1-4.158,2.727A4.651,4.651,0,0,1,85.752-6.48H97.578a13.319,13.319,0,0,0,.081-1.485,6.782,6.782,0,0,0-7.1-7.074c-4.32,0-7.317,2.943-7.317,7.614,0,4.7,3.1,7.668,7.317,7.668A6.653,6.653,0,0,0,97.362-4.563Zm2.754,9.585V4.779a20.929,20.929,0,0,0,5.67-14.661,20.653,20.653,0,0,0-6.075-15.093v-.243h2.565c3.834,3.537,5.886,9.234,5.886,15.336,0,6.075-2.052,11.529-5.481,14.9ZM119.853-8.856h10.773v-2.079H119.853Z",
    transform: "translate(-0.008 27.979)",
    fill: "#ff3030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(49.205 513.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M10.962,5.022V4.779A20.929,20.929,0,0,1,5.292-9.882a20.653,20.653,0,0,1,6.075-15.093v-.243H8.8C4.968-21.681,2.916-15.984,2.916-9.882c0,6.075,2.052,11.529,5.481,14.9Zm7.182-5L20.871,0l4.536-15.147L29.781,0h2.754l5.454-18.819H35.343l-4.131,15.9-4.32-15.9H24.138L19.6-2.862,15.5-18.819H12.879ZM40.689,0h2.457V-14.8H40.689Zm1.269-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674,1.648,1.648,0,0,0-1.674,1.674A1.648,1.648,0,0,0,41.958-17.2ZM47.331,0h2.457V-19.98H47.331Zm6.642,0H56.43V-19.98H53.973Zm5.859,5.022V4.779A20.929,20.929,0,0,0,65.5-9.882a20.653,20.653,0,0,0-6.075-15.093v-.243h2.565c3.834,3.537,5.886,9.234,5.886,15.336,0,6.075-2.052,11.529-5.481,14.9ZM79.569-8.856H90.342v-2.079H79.569ZM102.168,0h2.457V-13.959L110.862,0h1.728l6.21-13.932V0h2.457V-18.684h-2.619L111.726-3.24l-6.912-15.444h-2.646Zm37.287-7.425a7.222,7.222,0,0,0-7.479-7.614A7.237,7.237,0,0,0,124.5-7.425c0,4.7,3.186,7.668,7.371,7.668A7.336,7.336,0,0,0,139.455-7.425Zm-12.447,0c0-3.726,2.349-5.481,4.941-5.481,2.538,0,4.995,1.755,4.995,5.481,0,3.753-2.511,5.508-5.076,5.508S127.008-3.672,127.008-7.425ZM145.584,0h2.538l3.564-11.745L155.25,0h2.538L162.4-14.8h-2.43L156.627-2.349,153.036-14.8h-2.511l-3.672,12.42-3.4-12.42H140.94Zm19.251,0h2.457V-14.8h-2.457ZM166.1-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674,1.648,1.648,0,0,0-1.674,1.674A1.648,1.648,0,0,0,166.1-17.2ZM182.3,0h2.43V-8.721c0-4.239-2.619-6.345-6.048-6.345a5.466,5.466,0,0,0-4.752,2.376V-14.8h-2.457V0h2.457V-8.181c0-3.186,1.728-4.752,4.239-4.752,2.484,0,4.131,1.539,4.131,4.563Zm5.535-7.452c0,4.59,3.051,7.7,7.02,7.7a6.183,6.183,0,0,0,5.508-3.024V.324c0,3.159-1.971,4.833-4.59,4.833-2.43,0-4.185-1.215-4.725-3h-2.43c.486,3.159,3.267,5.13,7.155,5.13,4.347,0,7.074-2.889,7.074-6.966V-14.8h-2.484v2.7a6.1,6.1,0,0,0-5.508-2.943C190.89-15.039,187.839-12.069,187.839-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.295-5.454,5-5.454S200.367-10.854,200.367-7.425Zm22.383-11.61a9.283,9.283,0,0,0-9.45,9.612A9.26,9.26,0,0,0,222.75.162a9.127,9.127,0,0,0,9.234-8.424v-1.89H221.859v2h7.506a6.345,6.345,0,0,1-6.615,6.1c-3.969,0-6.939-2.862-6.939-7.371,0-4.536,2.97-7.4,6.939-7.4a6,6,0,0,1,5.724,3.456h2.943A8.9,8.9,0,0,0,222.75-19.035ZM237.681-8.046c0-3.429,1.782-4.482,4.131-4.482h.648v-2.538a4.983,4.983,0,0,0-4.779,2.673v-2.4h-2.457V0h2.457Zm6.7.594c0,4.59,3.051,7.7,6.993,7.7a6.179,6.179,0,0,0,5.535-3V0h2.484V-14.8H256.9v2.7a6.14,6.14,0,0,0-5.508-2.943C247.428-15.039,244.377-12.069,244.377-7.452Zm12.528.027c0,3.483-2.322,5.508-5.022,5.508s-5-2.052-5-5.535,2.295-5.454,5-5.454S256.9-10.854,256.9-7.425Zm17.28,3.4c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.105,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511h-2.538c.162,2.7,2.592,4.59,6.048,4.59C272.052.243,274.185-1.593,274.185-4.023Zm14.094,0c-.108-5.292-8.694-3.375-8.694-6.885,0-1.188,1.08-2.052,2.889-2.052,1.971,0,3.105,1.08,3.213,2.565h2.457c-.162-2.889-2.322-4.644-5.589-4.644-3.294,0-5.427,1.863-5.427,4.131,0,5.508,8.748,3.591,8.748,6.885,0,1.215-1.08,2.187-3.024,2.187-2.079,0-3.348-1.08-3.483-2.511h-2.538c.162,2.7,2.592,4.59,6.048,4.59C286.146.243,288.279-1.593,288.279-4.023Z",
    transform: "translate(-0.008 28.246)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(386.724 13.07)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    y1: 12.301,
    x2: 12.301,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d91b0e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 12.301,
    y2: 12.301,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d91b0e",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M0,4.119l6.5,6.5L17.109,0",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 350.065, 16.041)",
    fill: "none",
    stroke: "#429e55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M10.962,5.022V4.779A20.929,20.929,0,0,1,5.292-9.882a20.653,20.653,0,0,1,6.075-15.093v-.243H8.8C4.968-21.681,2.916-15.984,2.916-9.882c0,6.075,2.052,11.529,5.481,14.9Zm7.182-5L20.871,0l4.536-15.147L29.781,0h2.754l5.454-18.819H35.343l-4.131,15.9-4.32-15.9H24.138L19.6-2.862,15.5-18.819H12.879ZM40.689,0h2.457V-14.8H40.689Zm1.269-17.2a1.637,1.637,0,0,0,1.62-1.674,1.637,1.637,0,0,0-1.62-1.674,1.648,1.648,0,0,0-1.674,1.674A1.648,1.648,0,0,0,41.958-17.2ZM47.331,0h2.457V-19.98H47.331Zm6.642,0H56.43V-19.98H53.973Zm5.859,5.022V4.779A20.929,20.929,0,0,0,65.5-9.882a20.653,20.653,0,0,0-6.075-15.093v-.243h2.565c3.834,3.537,5.886,9.234,5.886,15.336,0,6.075-2.052,11.529-5.481,14.9ZM79.569-8.856H90.342v-2.079H79.569Z",
    transform: "translate(-0.008 28.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21-3",
    "data-name": "Group 21",
    transform: "translate(227.575 112.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3-3",
    "data-name": "Ellipse 3",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(-0.377 -0.422)",
    fill: "#75a483"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20-3",
    "data-name": "Group 20",
    transform: "translate(9.871 10.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-3",
    "data-name": "Path 6",
    d: "M3738,270.57v17.163",
    transform: "translate(-3729.418 -270.57)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-3",
    "data-name": "Path 7",
    d: "M0,0V17.163",
    transform: "translate(17.163 8.581) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/front.f8fba22d29ccb747df1bc0221d37bc48.svg";
export { ForwardRef as ReactComponent };